export enum ProtectionDetailsUpsellModalResult {
  ExtraProtection = 'extraProtection',
  ExtraProtectionPrepay = 'extraProtectionPrepay',
  RegistrationOnly = 'registrationOnly',
}
